export default __webpack_public_path__ + "static/media/Icon_Purple_Soundmoji.75129568.png";